import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './Interview.css';

const ExamEnded = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [mediaStream, setMediaStream] = useState(null);
  const navigate = useNavigate();
  const { id , courseName} = useParams();
 
  const handlePermissionAsk = () => {
    setIsLoading(true);
    navigator.mediaDevices.getUserMedia({ audio: true, video: true })
      .then((stream) => {
        setMediaStream(stream);
        setIsLoading(false);
        handlePermissionConfirmation(true, stream);
      })
      .catch((error) => {
        setIsLoading(false);
        handlePermissionConfirmation(false);
      });
  };

  const handlePermissionConfirmation = (permissionStatus, stream) => {
    if (permissionStatus) {
      navigate(`/enrolledCourse/ai-interview/${id}/${courseName}/exam`, { state: { mediaStream } });
    } else {
      setErrorMessage('You must grant permission to access your microphone and camera.');
    }
  };

  return (
    <div className="exam-ended-container">
           <p  >The exam has ended.</p>
          <button className="certificate-btn" onClick={() => navigate("/")}>Go to Home</button>
        </div>
  );
};

export default ExamEnded;
